import { ChangeDetectionStrategy, Component, computed, signal } from '@angular/core';
import { SvgIconComponent, hourglass01Icon, injectBxIcons, xCircleIcon } from '@beyonnex/bx-angular-ui';
import { TranslatePipe } from '@ngx-translate/core';
import type { ICellRendererAngularComp } from 'ag-grid-angular';
import type { ICellRendererParams } from 'ag-grid-community';
import type { PropertyStatus, StatusCounts } from '../../../../services/property-status/property-status.service.models';
import { PRODUCT_COLUMNS } from '../property-overview.models';

// AG Grid master/detail detail cell renderer: a property row expands to show the room group and
// device breakdown behind each status badge above it.
@Component({
  selector: 'bxi-property-overview-detail-renderer',
  imports: [SvgIconComponent, TranslatePipe],
  templateUrl: './property-overview-detail-renderer.component.html',
  host: { class: 'block' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PropertyOverviewDetailRendererComponent implements ICellRendererAngularComp {
  private readonly property = signal<PropertyStatus | undefined>(undefined);

  /** One slot per status column, in column order — the property totals first, then each product. */
  protected readonly slots = computed<(StatusCounts | undefined)[]>(() => {
    const property = this.property();
    if (!property) {
      return [];
    }

    // An absent product is one the property does not serve, and leaves its slot empty.
    return [property.totals, ...PRODUCT_COLUMNS.map((product) => property.products.find((entry) => entry.product === product))];
  });

  constructor() {
    injectBxIcons([xCircleIcon, hourglass01Icon]);
  }

  agInit(params: ICellRendererParams<PropertyStatus>): void {
    this.refresh(params);
  }

  refresh(params: ICellRendererParams<PropertyStatus>): boolean {
    this.property.set(params.data);

    return true;
  }
}
